(function () {
  'use strict';

  // Respect prefers-reduced-motion — skip all animations if set
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll fade-in — only targets elements NOT already managed by Dawn's scroll-trigger system
  function initReveal() {
    if (prefersReducedMotion) return;

    const targets = [
      '.product-card-wrapper:not(.scroll-trigger)',
      '.collection-card-wrapper:not(.scroll-trigger)',
      '.multicolumn-list__item:not(.scroll-trigger)',
    ];

    const elements = document.querySelectorAll(targets.join(','));
    if (!elements.length) return;

    elements.forEach((el) => {
      el.classList.add('fp-reveal');
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fp-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => observer.observe(el));
  }

  // Header glow on scroll
  function initHeaderScroll() {
    const header = document.querySelector('.section-header');
    if (!header) return;

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            if (window.scrollY > 60) {
              header.classList.add('section-header--sticky-scrolled');
            } else {
              header.classList.remove('section-header--sticky-scrolled');
            }
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initReveal();
      initHeaderScroll();
    });
  } else {
    initReveal();
    initHeaderScroll();
  }
})();
